import { CheckCircle2, ArrowRight } from "lucide-react";
import { buildBookingSmsHref } from "../lib/bookingSms";

const STACK = [
  { item: "Gtechniq Crystal Serum Light (9H hard base)", value: "$450", included: true },
  { item: "Gtechniq EXO v5 hydrophobic top coat", value: "$300", included: true },
  { item: "1-stage paint correction (swirl + scratch removal)", value: "$400", included: true, highlight: true, note: "FREE with content deal" },
  { item: "Full decontamination prep + iron / tar removal", value: "$150", included: true, highlight: true, note: "FREE with content deal" },
  { item: "Hand-applied labor (7-10 hours per car)", value: "$500", included: true, highlight: true, note: "FREE with content deal" },
  { item: "Gtechniq window coating (rain visibility)", value: "$150", included: true, highlight: true, note: "FREE with content deal" },
  { item: "Written 5-year manufacturer warranty", value: "$0", included: true },
  { item: "Documented before/after photo report", value: "$0", included: true },
  { item: "Free annual maintenance inspection", value: "$100/yr", included: true },
];

const TOTAL_VALUE = "$2,050+";
const YOUR_PRICE = "$550";

export default function ValueStack() {
  return (
    <section
      className="relative py-24 md:py-32 bg-gradient-to-b from-[#0c0119] via-[#1a0938] to-[#0c0119] border-y border-jester/30"
      data-testid="value-stack-section"
    >
      <div className="absolute -top-20 left-1/4 w-[500px] h-[500px] rounded-full bg-jester-purple/20 blur-[140px]" />
      <div className="absolute -bottom-20 right-1/4 w-[400px] h-[400px] rounded-full bg-acid/10 blur-[140px]" />

      <div className="relative max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="text-xs uppercase tracking-[0.3em] text-acid mb-5 font-label">
           Everything You Get. Salt-Proofed
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
            <span className="text-jester">$2,050+ of value.</span><br />
            You pay $550.
          </h2>
          <p className="mt-6 text-white/75 text-lg max-w-xl mx-auto leading-relaxed">
            Every dollar of prep, coating, correction and warranty stays in.
            The only trade is the content we shoot on pickup day. Ready
            before the first plow drops salt in your neighbourhood.
          </p>
        </div>

        <div className="rounded-3xl border border-jester/40 bg-[#120127]/80 backdrop-blur-md p-6 md:p-10 shadow-[0_0_80px_rgba(141,57,238,0.25)]">
          <ul className="space-y-1">
            {STACK.map((s, i) => (
              <li
                key={i}
                className={`flex items-start gap-4 py-3 border-b border-white/5 last:border-b-0 ${
                  s.highlight ? "bg-acid/[0.04] -mx-3 px-3 rounded-lg" : ""
                }`}
                data-testid={`stack-item-${i}`}
              >
                <CheckCircle2
                  className={`w-5 h-5 flex-shrink-0 mt-0.5 ${
                    s.highlight ? "text-acid" : "text-white/60"
                  }`}
                />
                <div className="flex-1 min-w-0">
                  <div
                    className="text-white text-[15px] md:text-base leading-snug"
                    dangerouslySetInnerHTML={{ __html: s.item }}
                  />
                  {s.note && (
                    <div className="mt-0.5 text-xs font-label uppercase tracking-[0.2em] text-acid">
                      {s.note}
                    </div>
                  )}
                </div>
                <div
                  className={`font-stencil text-lg md:text-xl flex-shrink-0 ${
                    s.highlight ? "text-white/40 line-through" : "text-white/70"
                  }`}
                >
                  {s.value}
                </div>
              </li>
            ))}
          </ul>

          <div className="mt-8 pt-6 border-t-2 border-jester/30 flex items-center justify-between gap-4">
            <div>
              <div className="text-xs uppercase tracking-[0.3em] text-white/50 font-label mb-1">
                Total Value
              </div>
              <div className="font-stencil text-3xl md:text-4xl text-white/40 line-through">
                {TOTAL_VALUE}
              </div>
            </div>
            <div className="text-right">
              <div className="text-xs uppercase tracking-[0.3em] text-acid font-label mb-1">
                Your Price
              </div>
              <div className="font-stencil text-4xl md:text-5xl text-acid">
                {YOUR_PRICE}
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={buildBookingSmsHref()}
            data-testid="value-stack-cta"
            className="group inline-flex items-center gap-3 px-8 h-14 rounded-full bg-acid hover:bg-[#bff020] text-[#120127] font-label tracking-[0.2em] text-sm uppercase transition-all shadow-[0_0_50px_rgba(168,224,0,0.5)]"
          >
            Lock In $550. Text Us
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
          <p className="text-xs text-white/50 font-label tracking-[0.15em] uppercase">
            Reply in an hour &middot; text or DM
          </p>
        </div>
      </div>
    </section>
  );
}
